import products from "./products.json";

//Fake api fetch
const getProducts = () => products;

export default { getProducts };
